<template>
    <h1 class="section-title lined" :class="{ active_: active }"
        v-scrollee="{ container: container, anchor: 'bottom', once: true, offset: 150 }"
        @scrollee="handle">
        <span ref="title" class="mask _body"><slot/></span>
    </h1>
</template>

<script>
export default {
    name: 'SectionTitle',
    props: {
        container: {
            default: () => window
        },
    },
    data() {
        return {
            active: false,
        }
    },
    methods: {
        async handle(e) {
            if (e.detail) {
                this.active = true
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import '~@/styles/_parts';

.section-title {
    margin-right: em(-20);
    margin-left: em(-20);
    @include media(640) {
        margin-right: 0;
        margin-left: 0;
    }
    &::before {
        transform: scaleX(0);
        transform-origin: center;
        transition: transform 275ms $ease-out;
        transition-delay: 275ms;
    }
    &.active_ {
        &::before {
            transform: none;
        }
        .mask._body {
            opacity: 1;
        }
    }
}
.mask._body {
    opacity: 0;
    padding: 0 em(24, 18);
    transition: opacity 275ms $ease-out;
}
</style>